import * as React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import CareFacilityUserAudit from '../components/Admin/AdminReports/CareFacilityUserAudit';
function CareFacilityUserAuditPage() {
    return (
            <>
        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} />
                </div>
            <div className="content-class">
                <CareFacilityUserAudit />
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
        </div>
            </>
        );
}

export default CareFacilityUserAuditPage;